module.exports = __webpack_public_path__ + "static/media/whatsapp.8f38b081.svg";